<template>
  <div>
    <el-form label-position="top" ref="ruleForm" :rules="rules" label-width="80px" :model="rulesForm">
      <vue-dividing-line title="基本設定"></vue-dividing-line>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="題目編號" prop="question_no">
            <el-input v-model="rulesForm.question_no" placeholder="請輸入題目編號"></el-input> </el-form-item
        ></el-col>
        <el-col :span="8">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- <el-col :span="8">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="8">
          <el-form-item label="分數" prop="score"> 
            <el-input-number v-model="rulesForm.score" controls-position="right" :min="1" placeholder="請輸入分數"></el-input-number>
          </el-form-item
        ></el-col>
        <!-- <el-col :span="8">
          <el-form-item label="難易程度" prop="level">
            <el-select v-model="rulesForm.level" placeholder="請選擇難度">
              <el-option v-for="(item, idx) in level" :key="idx"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item
        ></el-col> -->
      </el-row>
      <vue-dividing-line title="問題"></vue-dividing-line>
      <el-form-item label="問題" prop="title">
        <Tinymce v-model="rulesForm.title" ref="Tinymce"></Tinymce>
        <!-- <Tinymce v-model="rulesForm.title" ref="Tinymce"></Tinymce> -->
      </el-form-item>
      <!-- 
      <el-form-item label="問題圖片" prop="img_url">
        <upload :placeholder="rulesForm.img_url || '請選擇問題圖片'" @childByValue="onUploadSuccess"></upload>
        <div class="img-box" v-if="rulesForm.img_url">
          <div class="close" @click="rulesForm.img_url = ''"></div>
          <img :src="rulesForm.img_url" />
        </div>
      </el-form-item> -->
      <vue-dividing-line title="內容及答案"></vue-dividing-line>
      <Tinymce v-model="topic" ref="Tinymce"></Tinymce>
       
      <vue-dividing-line title="解答思路"></vue-dividing-line>
      <Tinymce v-model="rulesForm.explanation"></Tinymce>
      <div class="sibmit-button">
        <div class="left">
          <el-button type="info" @click="onSubmit">提交</el-button>
          <el-button type="success" @click="onBack">取消</el-button>
        </div>
        <el-button type="info" @click="preview">預覽題目</el-button>
      </div>

    </el-form>

  </div>
</template>

<script>
// import upload from "@/components/upload";
import Tinymce from "@/components/Tinymce";
import { symbol } from '../plugins/directive'
import rules from "../plugins/validator";
// import getNodeOffset from '../plugins/getNodeOffset'
import { debounce } from '../plugins/debounce'
let matrixArea = {
  minRow: -1,
  maxRow: -1,
  minCol: -1,
  maxCol: -1
}

export default {
  directives: {
    symbol
  },
  props: ['formLabelAlign'],
  components: { Tinymce },
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      topic: '',
      letter,
      // 语言
      lang: [
        {label: '中文', value: 0},
        {label: '英文', value: 1},
      ],
      // 难易程度
      level: [
        {label: '※', value: 1},
        {label: '※※', value: 2},
        {label: '※※※', value: 3},
        {label: '※※※※', value: 4},
        {label: '※※※※※', value: 5},
      ],
      rulesForm: {},
      // rulesForm: {
      //   id: '',
      //   lang: "",
      //   title: "",
      //   img_url: '',
      //   type: 2,
      //   score: 1,
      //   level: 1,
      //   explanation: '',
      //   answers: [],
      //   choices: [],
      //   content: '',
      // },
      rules,

      matrix: []
    };
  },
  watch: {
    'topic': function (v) {
      this.strConvertDom(v)
    }
  },
  methods: {
    strConvertDom(data) {
      let parser = new DOMParser(),
      doc = parser.parseFromString(data, 'text/html'),
      tr = doc.querySelectorAll('tr'),
      dataArr = []

      matrixArea = {
        minRow: -1,
        maxRow: -1,
        minCol: -1,
        maxCol: -1
      }
      if(tr.length == 0) return 
      
      for(let i = 0; i < tr.length; i ++) {
        dataArr[i] = []
        let td = tr[i].querySelectorAll('td')
        for(let j = 0; j < td.length; j++) {
          /**
           * 解析数据
           * type: 类型 (0: 定数, 1: 答案, -1: 空白, 东: -2, 南: -3, 西: -4 , 北: -5)
           * value: 内容
           */
          let value = td[j].innerText.trim(),
          itemData = {
            type: -1,
            row: j + 1,
            col: i + 1,
            value,
          },
          regex = /\(.+?\)/g,
          res = value.match(regex)

          if(value != '' && res) {
            itemData.type = 1
            if(matrixArea.minCol == -1 || matrixArea.minCol > i) (matrixArea.minCol = i)
            if(matrixArea.minRow == -1 || matrixArea.minRow > j) (matrixArea.minRow = j)
            i > matrixArea.maxCol && (matrixArea.maxCol = i)
            j > matrixArea.maxRow && (matrixArea.maxRow = j)
          } else if(value != '') {
            itemData.type = 0
            if(matrixArea.minCol == -1 || matrixArea.minCol > i) (matrixArea.minCol = i)
            if(matrixArea.minRow == -1 || matrixArea.minRow > j) (matrixArea.minRow = j)
            i > matrixArea.maxCol && (matrixArea.maxCol = i)
            j > matrixArea.maxRow && (matrixArea.maxRow = j)
          }

          if(value.match(/<(E|W|S|N)>/)) {
            let regex = value.match(/<(E|W|S|N)>/)[1]
            switch(regex) {
              case 'E': itemData.type = -2 ;break;
              case 'W': itemData.type = -3 ;break;
              case 'S': itemData.type = -4 ;break;
              case 'N': itemData.type = -5 ;break;
            }
          }

          dataArr[i].push(itemData)
        }
      }

      // console.log(dataArr)
      this.matrix = JSON.parse(JSON.stringify(dataArr))
    },
    debounce, 
    preview() {
      let form = this.handleFromData()
      // console.log(form)
      form.type = 10
      
      this.$emit('preview', form)
    },
    handleFromData() {
      let form = JSON.parse(JSON.stringify(this.rulesForm)),
      { topic, matrix } = this
      , { minRow, maxRow, minCol, maxCol } = matrixArea,
      example = [], choices = [], answers = []

      // console.log(matrixArea)
      if(minRow == -1) return {}
      for(let i = minCol; (i < matrix.length && i <= maxCol); i++) {
        let idx = i - minCol
        example[idx] = []
        for(let j = minRow; (j < matrix[idx].length && j <= maxRow); j++) {
          // content
          let data = {...matrix[i][j]}
          data.row -= minRow
          data.col -= minCol

          if(data.type == 1){
            let mockId = Math.floor(Math.random() * 100)
            // choices
            choices.push({id: mockId, value: ''})

            // answers
            const match = data.value.match(/\(([^)]+)\)/);  
            const content = match ? match[1] : null; 
            answers.push({id: mockId, value: content})

            data.value = '()'
          }
          example[idx].push(data)
        }
      }
      // console.log(form)
      // 分隔符 没有字段保存 跟别人凑活一下 嘿嘿
      form.explanation += '-----' + topic
      form.answers= answers
      form.choices = choices
      form.content = JSON.stringify(example)
      return form
    },
    // 提交
    onSubmit() {
      let form = this.handleFromData()
      // type, type_display
      // console.log(form)
      this.$emit('save', form, 10, 9)
    },
    // 返回
    onBack() {
      this.$emit('cancel', this.rulesForm)
    },
  },
  created() {
    this.rulesForm = {...this.formLabelAlign}
    let [explanation, html] = this.rulesForm.explanation.split('-----')
    this.rulesForm.explanation = explanation
    this.topic = html
  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>
.matrix {
  margin-top: 20px;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #f5f5f5;

  .column {
    width: 100%;
    display: flex;
    .row {
      width: 34px;
      height: 34px;
      padding: 2px;
      box-sizing: border-box;
      position: relative;
      border: 2px solid #fff;
      border-right: none;
      border-bottom: none;
      background-color: #ffcca519;
      // background-color: #ffcca5;
      transition: background-color .3s ease-in-out;

      &:hover {
        background-color: #ffcca5;
      }

      input[type="text"] {
        outline: none;
        border: none;
        width: 100%;
        height: 100%;
        background-color: transparent;
        text-align: center;
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        width: 2px;
        height: 100%;
        background-color: #fff;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 2px;
        background-color: #fff;
      }
    }
  }
}
.right-key-menu {
  width: 150px;
  padding: 5px 0;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 1px 1px 3px 1px #ccc;
  border-radius: 3px;
  position: absolute;
  top: -1000px;
  z-index: 9999;
  outline: none;

  .menu-single {
    width: 100%;
    padding: 5px;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    font-size: 13px;
    text-align: center;
    cursor: pointer;

    &:hover {
      background-color: #eee;
    }
  }

  .menu-single:nth-last-of-type(1) {
    border: none;
  }
}
</style>
